import {Injectable} from '@angular/core';
import {RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingState: boolean;
  private loadingTasks = 0;

  private loading$ = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {
    // Show loader based on router events
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.startLoading();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.stopLoading();
      }
    });
  }

  public startLoading() {
    this.loadingTasks++;

    if (this.loadingTasks > 0) {
      this.loadingState = true;
      this.loading$.next(this.loadingState);
    }
  }

  public stopLoading() {
    this.loadingTasks--;

    if (this.loadingTasks <= 0) {
      this.loadingState = false;
      this.loading$.next(this.loadingState);
    }
  }

  public toggleLoading() {
    if (this.loadingState) {
      this.stopLoading();
    } else {
      this.startLoading();
    }
  }

  public get loading(): Observable<boolean> {
    return this.loading$.asObservable();
  }
}
